import type { OnboardingRequirement } from '@onefootprint/request-types';
import UAParser from 'ua-parser-js';

// Checks if the current device supports app clips (ios 16+ safari on mobile)
const deviceHasSupport = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const uaParser = new UAParser();
  const device = uaParser.getDevice();
  const os = uaParser.getOS();
  const browser = uaParser.getBrowser();

  const isIOS = os.name === 'iOS';
  const isMobileDevice = device.type === 'mobile' || device.type === 'tablet';
  const osVersion = os.version ? Number.parseFloat(os.version) : 0;
  const supportsAppClipVersion = osVersion >= 16;
  const isSafari = browser.name === 'Safari' || browser.name === 'Mobile Safari';

  return isIOS && isMobileDevice && supportsAppClipVersion && isSafari;
};

// Our appclip currently only supports identity documents and passkeys
const requiresIdDocOrPasskey = (missingRequirements: OnboardingRequirement[]): boolean => {
  return missingRequirements.every(d => {
    if (d.kind === 'collect_document') {
      return d.config.kind === 'identity';
    }
    if (d.kind === 'liveness') {
      return true;
    }
    return false;
  });
};

// Checks if app clip is supported for the current device and requirements
const hasAppclipSupport = (missingRequirements: OnboardingRequirement[]): boolean => {
  return deviceHasSupport() && requiresIdDocOrPasskey(missingRequirements);
};

export default hasAppclipSupport;
